import { ReactComponent as Signal0 } from "assets/svgs/network/signal0.svg";
import { ReactComponent as Signal1 } from "assets/svgs/network/signal1.svg";
import { ReactComponent as Signal2 } from "assets/svgs/network/signal2.svg";
import { ReactComponent as Signal3 } from "assets/svgs/network/signal3.svg";
import { ReactComponent as Signal4 } from "assets/svgs/network/signal4.svg";
import { ReactComponent as Signal5 } from "assets/svgs/network/signal5.svg";

/** SVG root from SVGR — explicit size so icons are not collapsed in tables/flex. */
const iconFrame = "inline-block h-4 w-4 shrink-0 align-middle";

const SIGNAL_ICONS = {
    0: Signal0,
    1: Signal1,
    2: Signal2,
    3: Signal3,
    4: Signal4,
    5: Signal5,
} as const;

type SignalLevel = keyof typeof SIGNAL_ICONS;

/**
 * Map 0–100% quality to signal0–signal5 bars (20% steps).
 * signal0 also covers disabled / no mobile network.
 */
export function percentToSignalLevel(percent: number): SignalLevel {
    if (!(percent > 0)) return 0;
    return Math.min(5, Math.max(1, Math.round(percent / 20))) as SignalLevel;
}

type Props = {
    /** Signal quality 0–100. Values ≤0 use signal0. */
    status?: number;
    className?: string;
};

const MobileSignalIcon: React.FC<Props> = ({ status = 0, className = "" }) => {
    const level = percentToSignalLevel(status);
    const Icon = SIGNAL_ICONS[level];

    let tint = "text-white/50";
    if (level > 0) {
        if (status >= 75) {
            tint = "text-white";
        } else if (status >= 25) {
            tint = "text-low";
        } else {
            tint = "text-warning";
        }
    }

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <Icon className={`${iconFrame} ${tint}`} />
        </div>
    );
};

export default MobileSignalIcon;
